/**
 * @fileoverview Builds the grouped view-model for ChatView.
 * @module pages/chat/buildChatViewModel
 */
import { getSearchBarWidth } from "../../logic/chat/index.js";

/**
 * @param {Object} ctx - Chat context
 * @param {Object} handlers - Chat handlers
 * @returns {Object} Props for ChatView
 */
export const buildChatViewModel = (ctx, handlers) => ({
  allowed: ctx.allowed,
  t: ctx.t,
  navigate: ctx.navigate,
  searchBarWidth: getSearchBarWidth(ctx.searchBarDevice),
  header: {
    searchQuery: ctx.searchQuery,
    onSearch: handlers.handleSearch,
  },
  inbox: {
    activeView: ctx.activeView,
    chats: ctx.chats,
    searchQuery: ctx.searchQuery,
    users: ctx.users,
    companies: ctx.companies,
    selectedChat: ctx.selectedChat,
    activeConnections: ctx.activeConnections,
    connectionRequests: ctx.connectionRequests,
    onChatSelect: handlers.handleChatSelection,
    onViewChange: handlers.handleViewChange,
    hideInbox: ctx.isCompactViewport && ctx.showChatInTablet,
  },
  connectionRequests: {
    connectionRequests: ctx.connectionRequests,
    onViewChange: handlers.handleViewChange,
    activeView: ctx.activeView,
    chats: ctx.chats,
    onChatsUpdate: ctx.setChats,
    onChatParticipantsUpdate: ctx.setChatParticipants,
    onConnectionRequestsUpdate: ctx.setConnectionRequests,
    navigate: ctx.navigate,
    onSimulatedChatOpen: handlers.handleSimulatedChatOpen,
  },
  chatContainer: {
    selectedChat: ctx.selectedChat,
    selectedUser: ctx.selectedUser,
    selectedCompany: ctx.selectedCompany,
    chatMessages: ctx.chatMessages,
    messageInput: ctx.messageInput,
    setMessageInput: ctx.setMessageInput,
    messageEndRef: ctx.messageEndRef,
    activeConnections: ctx.activeConnections,
    isReconnecting: ctx.isReconnecting,
    isUserActive: ctx.isUserActive,
    showFileUpload: ctx.showFileUpload,
    selectedFile: ctx.selectedFile,
    isFileUploading: ctx.isFileUploading,
    isDragging: ctx.isDragging,
    fileError: ctx.fileError,
    users: ctx.users,
    setChats: ctx.setChats,
    setSelectedChat: ctx.setSelectedChat,
    setSelectedUser: ctx.setSelectedUser,
    onSendMessage: handlers.handleSendMessage,
    onKeyPress: handlers.handleKeyPress,
    onAttachFilesClick: handlers.handleAttachFilesClick,
    onFileUploadClose: handlers.handleFileUploadClose,
    onFileClick: handlers.handleFileClick,
    onFileChange: handlers.handleFileChange,
    onDragOver: handlers.handleDragOver,
    onDragLeave: handlers.handleDragLeave,
    onDrop: handlers.handleDrop,
    onBackToInbox: handlers.onBackToInbox,
    showChat: ctx.isCompactViewport && ctx.showChatInTablet,
    readOnly: ctx.isReadOnlyChat,
    headerTitleOverride: ctx.readOnlyHeaderTitle,
    readOnlyRequestType: ctx.readOnlyRequestType,
    readOnlyRequest: ctx.readOnlyRequest,
    onConnectionRequestsUpdate: ctx.setConnectionRequests,
    onChatParticipantsUpdate: ctx.setChatParticipants,
    onClearReadOnlyChat: handlers.clearReadOnlyChat,
  },
  overlay: {
    loading: ctx.loading || ctx.connectionRequestsLoading,
  },
});
